import React from 'react';
import { motion } from 'framer-motion';
export function PremiumCTA() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative z-20 flex justify-center px-4 -mt-12 md:-mt-16" data-id="element-161" data-mp="wyji4henh6ch">
      <motion.button onClick={scrollToPurchase} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} whileHover={{
      scale: 1.02,
      transition: {
        duration: 0.2
      }
    }} whileTap={{
      scale: 0.98
    }} className="group relative overflow-hidden rounded-full px-8 md:px-16 py-4 md:py-5 flex items-center justify-center gap-3 bg-gradient-to-r from-[#0a192f] via-[#112240] to-[#0a192f] border border-blue-400/20 shadow-[0_20px_40px_-12px_rgba(10,25,47,0.5)] transition-all duration-300 pt-[0px] pb-[0px] pl-[0px] pr-[0px]" data-id="element-162" data-mp="11xmihojoqoe4">
        {/* Inner Glow Highlight */}
        <div className="absolute inset-0 rounded-full shadow-[inset_0_0_20px_rgba(34,211,238,0.1)] pointer-events-none" data-id="element-163" data-mp="1uligqxowkod0" />

        {/* Shimmer Effect */}
        <motion.div animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear',
        repeatDelay: 2
      }} className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-400/10 to-transparent skew-x-12 pointer-events-none" data-id="element-164" data-mp="15z9nt9vsz0q" />

        {/* Breathing Glow */}
        <motion.div animate={{
        opacity: [0.3, 0.6, 0.3],
        scale: [1, 1.05, 1]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute inset-0 bg-cyan-400/5 blur-xl pointer-events-none" data-id="element-165" data-mp="3jcnbna9mx626" />

        {/* Button Content */}
        <span className="relative z-10 text-white font-black text-sm md:text-base tracking-[0.2em] uppercase flex items-center pt-[10px] pb-[10px] gap-[0px]" data-id="element-166" data-mp="35l8l8idee2l3">
          ACCEDER AL SISTEMA PROFESIONAL{' '}
          <span className="text-cyan-400" data-id="element-167" data-mp="2vnc7rjwzmvjt">✦</span>
        </span>

        {/* Delicate Border Highlight */}
        <div className="absolute inset-0 rounded-full border border-white/5 pointer-events-none" data-id="element-168" data-mp="2lwu8cu8gazng" />
      </motion.button>
    </div>;
}